<template>
    <transition name="fade-in" mode="out-in">
        <div
            v-show="indexes.length"
            class="component component__bulkactions"
        >
            <div class="columns is-vcentered">
                <div class="column is-narrow" v-if="items.length">
                    <div class="component__bulkactions_label">
                        {{ label }}
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="component__bulkactions_field">
                        <form-select
                            :name="'bulk-select'"
                            :label="''"
                            :value="action"
                            :items="items"
                            :is-type="'select'"
                            :placeholder="$t('shared.components.labels.bulk')"
                            :multiple="false"
                            :searchable="true"
                            @input="emitSubmit"
                        />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import FormSelect from '@/components/default/forms/FormSelect'

export default {
  components: { FormSelect },
  name: 'component-bulk-actions',
  data () {
    return {
      indexes: [],
      action: ''
    }
  },
  props: {
    name: {
      type: String,
      default: 'item'
    },
    emitName: {
      type: String,
      default: 'checkbox-action'
    },
    items: {
      type: [Array, Object],
      required: true
    }
  },
  computed: {
    label: function () {
      const count = this.indexes.length
      const name = count !== 1 ? `${this.name}s` : this.name
      return `${count} ${name} ${this.$t('shared.components.return.selected')}`
    }
  },
  methods: {
    getBulkItems: function (data) {
      if (!this.indexes.includes(data.index)) {
        if (!data.value) return
        this.indexes.push(data.index)
      } else {
        if (data.value) return
        const itemIndex = this.indexes.findIndex(item => {
          return item === data.index
        })
        this.indexes.splice(itemIndex, 1)
      }
    },
    emitSubmit: function (value) {
      this.action = value.value
      if (this.action === '' || this.action === null) {
        return
      }
      this.$emit('submit', { indexes: this.indexes, action: this.action })
    }
  },
  mounted () {
    this.$eventBus.$on(this.emitName, this.getBulkItems)
  },
  beforeDestroy () {
    this.$eventBus.$off(this.emitName)
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentbulkactions";
</style>
